import React from 'react'
import { Translation, useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from '@material-ui/core'
import PushPinIcon from '@mui/icons-material/PushPin'
import ReactPaginate from 'react-paginate'
import { scrollToTop } from '../../utils/scrollTo'
import NavButton from './navButton.component'
import { industryRender } from '../../utils/showIndustry.utils'
import mobileView from '../../utils/mobile.utils'
import ExpandablePanel from '../../utils/expandablePanel'
import AssignmentDetails from './assignmentDetails.component'
import PreviewOpenForWorkProfile from './previewOpenForWorkProfile.component'
import {
  AssignmentFilters,
  convertPortfolioNameLinksToObject,
  convertToObjects,
  rearrangeByPinned,
  searchAssignments
} from '../../utils/openForWork.utils'
import moment from 'moment'
import { CloseIcon } from './closeIcon.component'
import FontAwesome from 'react-fontawesome'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'

class AssignmentsComponent extends React.Component {
  componentDidMount() {
    this.props.getAreaOfWork()
    this.props.trackApplication()
    this.props.getAssignmentOfferToEmail()
    this.props.getAllAssignments()
    this.props.loadOpenForWorkStart()
    this.props.getFieldOfWork()
    this.props.loadProfileStart()
    this.props.getBillableHourUser()
    scrollToTop()
  }
  render() {
    return <Assignments {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    backgroundColor: '#E0EFF3',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  textField1: {
    marginTop: theme.spacing(4),
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  button: {
    margin: 15
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  tableCell: {
    fontSize: '13px'
  },
  tableCell2: {
    fontSize: '13px',
    padding: '5px',
    height: '30px',
    verticalAlign: 'top'
  },
  tableCell1: {
    border: 'none',
    fontSize: '13px',
    verticalAlign: 'top',
    maxWidth: '1000px',
    wordWrap: 'break-word'
  },
  expandP: {
    fontWeight: 1000
  },
  labelP: {
    fontWeight: 1000,
    paddingTop: '20px'
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    border: 'none'
  },
  tablecell2: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    border: 'none',
    padding: 0,
    height: '30px'
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between',
    background: '#FFFFFF'
  },
  filterFields: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px 30px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px 30px',
      alignItems: 'stretch'
    }
  },
  applied: {
    backgroundColor: '#ebf9fa'
  },
  checkbox: {
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  },
  assignmentsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '15px',
    marginTop: '15px'
  },
  assignmentCard: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '3px',
    padding: '15px',
    flex: '1 1 calc(50% - 10px)' /* Ensures two cards per row */,
    minWidth: '300px',
    maxWidth: '49%',
    '&:hover': {
      cursor: 'pointer',
      padding: '14px',
      border: '1px solid #44c0cc'
    }
  },
  newAssignment: {
    border: '2px solid #F67131'
  },
  assignmentCardInfo: {
    display: 'flex',
    gap: '15px',
    flex: '1 1 calc(50% - 20px)' /* Ensures two cards per row */,
    position: 'relative'
  },
  pin: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  },
  companyName: {
    width: '125px',
    height: '125px',
    borderRadius: '50%',
    backgroundColor: '#80808040',
    alignContent: 'center',
    '& > p': {
      marginLeft: '10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  assignmentContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between'
  },
  h3: {
    margin: 0,
    fontWeight: 'bold',
    fontSize: '13px',
    color: '#000000'
  },
  title: {
    marginTop: '4px',
    fontSize: '13px',
    color: '#000000'
  },
  description: {
    color: '#7D7D7D',
    fontSize: '12px'
  },
  cardBottom: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewField: {
    minHeight: '70px'
  }
})

const defaultValues = {
  job_title: '',
  industry: [],
  company_name: '',
  city_name: '',
  pageSize: 10,
  pinned: false,
  status: false,
  newAssignment: false
}

const Assignments = ({
  classes,
  filteredAssignmentRows,
  applyAssignment,
  showApplyForm,
  cancelApplyAssignment,
  assignmentPageSize,
  userData,
  sendApplication,
  applySuccess,
  closeSuccessSendApplication,
  trackApplication,
  areaOfWorkDict,
  updateViewAssignment,
  pinAssignment,
  openForWorkFormValues,
  applicationProfileData,
  ratingsByCompany,
  ratingsSummary
}) => {
  const history = useHistory()
  const [isSearchAssignment, setIsSearchAssignment] = React.useState(false)
  const [selectedAssignment, setSelectedAssignment] = React.useState(null)
  const [appliedProfileOpen, setAppliedProfileOpen] = React.useState(false)
  const [searchAssignmentValues, setSearchAssignmentValues] =
    React.useState(defaultValues)
  const [page, setPage] = React.useState(0)

  const { t } = useTranslation()

  const filteredPinnedAssignments = rearrangeByPinned(
    searchAssignments(filteredAssignmentRows, searchAssignmentValues).sort(
      (a, b) => b.assignment_id - a.assignment_id
    ),
    'pinned_assignment_user'
  )

  let assignmentType = ''
  if (selectedAssignment?.assignment_type === 'until_further_notice') {
    assignmentType = t('assignmentType.1')
  } else if (selectedAssignment?.assignment_type === 'temporary') {
    assignmentType = t('assignmentType.2')
  } else if (selectedAssignment?.assignment_type === 'temporary_with_notice') {
    assignmentType = t('assignmentType.3')
  } else if (selectedAssignment?.assignment_type === 'until_completion') {
    assignmentType = t('assignmentType.4')
  }
  let salaryModel = ''
  if (selectedAssignment?.salary_model === 'hourly_rate') {
    salaryModel = t('salaryModel.1')
  } else if (selectedAssignment?.salary_model === 'contract_price') {
    salaryModel = t('salaryModel.2')
  } else if (selectedAssignment?.salary_model === 'unit_price') {
    salaryModel = t('salaryModel.3')
  } else if (selectedAssignment?.salary_model === 'commission') {
    salaryModel = t('salaryModel.4')
  }

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <div className="container">
              <div className="row">
                <div className="dashboard-content-header">
                  <h1></h1>
                </div>
              </div>
              <NavButton t={t} type="openforwork" />
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <ExpandablePanel
                      title={t('assignment.h1')}
                      renderBody={() => (
                        <div className={classes.root}>
                          <AssignmentFilters
                            t={t}
                            filters={searchAssignmentValues}
                            onChange={setSearchAssignmentValues}
                            classes={classes}
                            resetSelectedPage={() => setPage(0)}
                          />
                          {createAssignmentTable(
                            t,
                            classes,
                            page,
                            filteredPinnedAssignments,
                            setSelectedAssignment,
                            searchAssignmentValues?.pageSize ??
                              assignmentPageSize,
                            updateViewAssignment,
                            pinAssignment
                          )}
                          {filteredPinnedAssignments.length > 0 ? (
                            <ReactPaginate
                              previousLabel={
                                <i className="fa fa-chevron-left" />
                              }
                              nextLabel={<i className="fa fa-chevron-right" />}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={
                                !!filteredPinnedAssignments
                                  ? Math.ceil(
                                      filteredPinnedAssignments.length /
                                        searchAssignmentValues.pageSize
                                    )
                                  : 0
                              }
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={(event) => {
                                setPage(event.selected)
                              }}
                              containerClassName={'pagination'}
                              subContainerClassName={'pages pagination'}
                              activeClassName={'active'}
                              forcePage={page}
                            />
                          ) : null}
                        </div>
                      )}
                      defaultExpanded={true}
                      isSearchAssignment={isSearchAssignment}
                      setIsSearchAssignment={setIsSearchAssignment}
                      pageLocation="open_for_work_assignments"
                    />
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              open={selectedAssignment !== null}
              onClose={() => setSelectedAssignment(null)}
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => setSelectedAssignment(null)}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    textAlign: 'center',
                    color: '#000000',
                    fontSize: '15px'
                  }}
                >
                  {t('assignment.title3')}
                </div>
              </DialogTitle>
              <DialogContent>
                <div>
                  <AssignmentDetails
                    t={t}
                    classes={classes}
                    assignmentType={assignmentType}
                    salaryModel={salaryModel}
                    areaOfWorkDict={areaOfWorkDict}
                    industryRender={industryRender}
                    company_name={selectedAssignment?.company_name}
                    location={selectedAssignment?.location}
                    amount={selectedAssignment?.amount}
                    contract_salary={selectedAssignment?.contract_salary}
                    unit_price={selectedAssignment?.unit_price}
                    hourly_rate={selectedAssignment?.hourly_rate}
                    weekly_hours={selectedAssignment?.weekly_hours}
                    job_title={selectedAssignment?.job_title}
                    assignment_begins={selectedAssignment?.assignment_begins}
                    assignment_ends={selectedAssignment?.assignment_ends}
                    status={selectedAssignment?.status}
                    agreement_status_entrepreneur={
                      selectedAssignment?.agreement_status_entrepreneur
                    }
                    industry={selectedAssignment?.industry}
                    last_date_of_application={
                      selectedAssignment?.last_date_of_application
                    }
                    type_of_employment={selectedAssignment?.type_of_employment}
                    notice_period={selectedAssignment?.notice_period}
                    job_description={selectedAssignment?.job_description}
                    assignment_id={selectedAssignment?.assignment_id}
                    enterpreneur_email={null}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                {(selectedAssignment?.status === 1 ||
                  selectedAssignment?.status === 2) && (
                  <Button
                    variant="contained"
                    style={{ fontSize: '13px', marginTop: '10px' }}
                    onClick={() => applyAssignment(selectedAssignment)}
                  >
                    {t('assignment.btn9')}
                  </Button>
                )}
              </DialogActions>
            </Dialog>
            <Dialog
              open={showApplyForm || appliedProfileOpen}
              onClose={() => {
                cancelApplyAssignment()
                setAppliedProfileOpen(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{
                classes: {
                  root: classes.dialog
                }
              }}
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => {
                  cancelApplyAssignment()
                  setAppliedProfileOpen(false)
                }}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <span style={{ fontSize: '20px' }}>
                    {t('assignment.title')}
                  </span>
                  <div style={{ color: '#000000' }}>
                    <p>
                      {selectedAssignment?.company_name} |{' '}
                      {selectedAssignment?.job_title} |{' '}
                      {selectedAssignment?.location}
                    </p>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                {!appliedProfileOpen ? (
                  <PreviewOpenForWorkProfile
                    t={t}
                    classes={classes}
                    formValues={openForWorkFormValues}
                    profile_pic={
                      openForWorkFormValues?.inputImage
                        ? openForWorkFormValues?.inputImage
                        : ''
                    }
                    userData={userData}
                    portfolios={openForWorkFormValues?.OpenWorkAttachments.filter(
                      (el) => el.AttachmentType === 4
                    )}
                    AreaOf_Expertise={openForWorkFormValues?.AreaOf_Expertise}
                    role_title={openForWorkFormValues?.role_title}
                    short_des={openForWorkFormValues?.short_des}
                    inputCV={openForWorkFormValues?.inputCV}
                    CV_file={openForWorkFormValues?.CV_file}
                    linkRow={openForWorkFormValues?.linkRow}
                    experienceInputRow={
                      openForWorkFormValues?.experienceInputRow
                    }
                    ratingsByCompany={ratingsByCompany}
                    ratingsSummary={ratingsSummary}
                    info_consent_allowed={
                      openForWorkFormValues?.info_consent_allowed
                    }
                  />
                ) : (
                  <div>
                    <PreviewOpenForWorkProfile
                      t={t}
                      classes={classes}
                      formValues={applicationProfileData}
                      profile_pic={applicationProfileData?.profile_image_path}
                      userData={null}
                      applicant_name={applicationProfileData?.applicant_name}
                      applicant_email={applicationProfileData?.applicant_email}
                      applicant_phone_no={
                        applicationProfileData?.applicant_phone_no
                      }
                      portfolios={convertToObjects(
                        applicationProfileData?.merged_filepaths
                      )}
                      AreaOf_Expertise={applicationProfileData?.area_of_expertise
                        .split(',')
                        .map((num) => Number(num.trim()))}
                      role_title={applicationProfileData?.title}
                      short_des={applicationProfileData?.short_description}
                      inputCV={applicationProfileData?.cv_path}
                      CV_file={applicationProfileData?.cv_filename}
                      linkRow={convertPortfolioNameLinksToObject(
                        applicationProfileData?.portfolio_name_link
                      )}
                      work_experience={applicationProfileData?.work_experience}
                    />
                    <div className="pull-right" style={{ marginTop: '10px' }}>
                      <b>
                        {t('assignment.p')}{' '}
                        {moment(applicationProfileData?.applied_date).format(
                          'DD.MM.YYYY'
                        )}
                      </b>
                    </div>
                  </div>
                )}
              </DialogContent>
              <DialogActions>
                {!appliedProfileOpen ? (
                  <div className="pull-right">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        history.push('/dashboard/profile/openforwork')
                      }}
                    >
                      {t('assignment.btn6')}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        sendApplication(selectedAssignment, ratingsByCompany)
                      }}
                    >
                      {t('assignment.btn5')}
                    </Button>
                  </div>
                ) : null}
              </DialogActions>
            </Dialog>
            <Dialog
              open={applySuccess}
              // onClose={closeSuccessSendApplication}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{
                classes: {
                  root: classes.dialog
                }
              }}
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('assignment.title2')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('assignment.content')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      closeSuccessSendApplication()
                      trackApplication()
                      setSelectedAssignment(null)
                    }}
                  >
                    {t('assignment.btn7')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          </>
        )
      }}
    </Translation>
  )
}

const createAssignmentTable = (
  t,
  classes,
  selected,
  filteredPinnedAssignments,
  setSelectedAssignment,
  assignmentPageSize,
  updateViewAssignment,
  pinAssignment
) => (
  <div className={classes.assignmentsContainer}>
    {filteredPinnedAssignments
      .slice(
        selected * assignmentPageSize,
        selected * assignmentPageSize + assignmentPageSize
      )
      .map((row, index) => (
        <AssignmentCard
          t={t}
          data={row}
          key={index}
          classes={classes}
          setSelectedAssignment={setSelectedAssignment}
          updateViewAssignment={updateViewAssignment}
          pinAssignment={pinAssignment}
        />
      ))}
  </div>
)

const AssignmentCard = ({
  t,
  data,
  classes,
  setSelectedAssignment,
  updateViewAssignment,
  pinAssignment
}) => {
  const jobDescription =
    data.job_description?.length > 150
      ? data.job_description?.slice(0, 150) + '...'
      : data.job_description

  const dueDate = new Date(data.last_date_of_application)
  const formattedDueDate = `${String(dueDate?.getDate()).padStart(
    2,
    '0'
  )}.${String(dueDate?.getMonth() + 1).padStart(2, '0')}.${String(
    dueDate?.getFullYear()
  )}`

  return (
    <div
      className={classes.assignmentCard}
      onClick={() => {
        setSelectedAssignment(data),
          data.is_assignment_viewed === 0 &&
            updateViewAssignment(data.assignment_id, data.uuid)
      }}
    >
      <div className={classes.assignmentCardInfo}>
        <IconButton
          aria-label="expand row"
          size="small"
          className={classes.pin}
          style={data.pinned_assignment_user ? { color: '#F67131' } : {}}
          onClick={(e) => {
            e.stopPropagation()
            pinAssignment(data.assignment_id)
          }}
        >
          <PushPinIcon fontSize="large" />
        </IconButton>
        {/* )} */}
        <div
          className={classNames(
            classes.companyName,
            data.is_assignment_viewed === 0 && classes.newAssignment
          )}
        >
          <p>{data.company_name}</p>
        </div>

        <div className={classes.assignmentContent}>
          <div>
            <h3 className={classes.h3}>
              {data.job_title}
              {data.is_assignment_viewed === 0 && (
                <span style={{ color: '#F67131', textTransform: 'lowercase' }}>
                  {' (new)'}
                </span>
              )}
            </h3>
            <p className={classes.title}>{data.company_name}</p>
            <span
              className={classes.description}
              dangerouslySetInnerHTML={{
                __html: jobDescription
              }}
            ></span>
          </div>
          <div className={classes.cardBottom}>
            <div style={{ marginRight: '10px' }}>
              {t('assignment.col6a') + ' ' + formattedDueDate}
            </div>
            <div>
              <FontAwesome name="map-marker" size="lg" /> {data.location}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AssignmentsComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AssignmentsComponent)
